export default async function ({ store, redirect, app, $session }) {
  store.dispatch('admin/userStore/healthCheck').then(result => {
    console.log(`api: v${result} 🥳`)
  })
  store.dispatch('cliente/clienteStore/healthCheck').then(result => {
    console.log(`crm: v${result} 😎`)
  })
  store.dispatch('inventario/itemStore/healthCheck').then(result => {
    console.log(`jit: v${result}  🤯`)
  })
}
